const QueryParams = require('../../../../page/frontend/helpers/params');

module.exports = class DealFetcher {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
    this.cachedPaginatedCards = {};
  }

  fetchLazyLoadedCards(lazyLoadedSectionIndex = 1) {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;
    paramObject['index'] = lazyLoadedSectionIndex;

    const url = `/partial/browse/get-lazy-loaded-cards?${QueryParams.toString(
      paramObject
    )}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchBottomSlot() {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;

    const url = `/partial/browse/get-bottom-slot?${QueryParams.toString(
      paramObject
    )}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchCards(paramObject) {
    paramObject['_csrf'] = this.csrfToken;

    const url = `/partial/browse/get-paginated-cards?${QueryParams.toString(
      paramObject
    )}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }

  fetchFacets() {
    const paramObject = Groupon.Utils.unparam();
    paramObject['_csrf'] = this.csrfToken;

    const url = `/partial/browse/get-page-header-and-facets?${QueryParams.toString(
      paramObject
    )}`;

    return fetch(url, { credentials: 'include' })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      });
  }
};
